import LocalStorageService from '@/services/LocalStorageService';
import axios from 'axios';
import consts from '@/static/js/consts';

export default {

  login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(consts.ENDPOINTS.AUTH_LOGIN, payload)
        .then((response) => {
          LocalStorageService.set('token', response.data.data.token);
          commit('setToken', response.data.data.token);
          resolve(response.data.data.token);
        })
        .catch((error) => reject(error.message || error.response));
    });
  },

  register({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(consts.ENDPOINTS.REGISTER, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error.message || error.response));
    });
  },

  validateToken({ }) {
    return new Promise((resolve, reject) => {
      axios.get(consts.ENDPOINTS.CHECK_TOKEN)
        .then((response) => resolve(response))
        .catch((error) => reject(error.message || error.response));
    });
  },

  forgotPassword({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(consts.ENDPOINTS.AUTH_FORGOT_PASSWORD, payload)
        .then((response) => { resolve(response); })
        .catch((error) => { reject(error.message || error.response); });
    });
  },

  resetPassword({ }, payload) {
    return new Promise((resolve, reject) => {
      axios.post(consts.ENDPOINTS.AUTH_RESET_PASSWORD, payload)
        .then((response) => { resolve(response); })
        .catch((error) => { reject(error.message || error.response); });
    });
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      axios.delete(consts.ENDPOINTS.AUTH_LOGOUT)
        .then((response) => {
          LocalStorageService.removeStorageFrom('token');
          commit('removeAuthData');
          resolve(response);
        })
        .catch((error) => { reject(error.message || error.response); });
    });
  },

};
